<template>
  <v-btn :fab="fab" :large="large" :x-large="xlarge" :absolute="absolute" :width="width" :height="height" :color="color"
    :depressed="depressed" @click="eventClick()">
    <slot></slot>
  </v-btn>
</template>

<script>
export default {
  name: "Button",
  props: {
    fab: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    xlarge: {
      type: Boolean,
      default: false
    },
    absolute: {
      type: Boolean,
      default: false
    },
    width: {
      default: 'unset'
    },
    height: {
      default: '30px'
    },
    depressed: {
      type: Boolean,
      default: true
    },
    color: {
      default: 'var(--theme-one)'
    }
  },
  methods: {
    eventClick() {
      this.$emit('onClick')
    }
  }
}
</script>

<style scoped></style>